import { useState } from 'react';
import type { PictoSource } from '../lib/picto';

/**
 * Draws a symbol image (bundled symbol or uploaded photo) or, as a fallback
 * (missing file, offline, no image), the emoji.
 */
export function Pictogram({ source, className = '' }: { source: PictoSource; className?: string }) {
  const [failed, setFailed] = useState<string | null>(null);
  const src = source.image || null;

  if (src && failed !== src) {
    return (
      <img
        className={`picto ${className}`}
        src={src}
        alt=""
        draggable={false}
        loading="lazy"
        decoding="async"
        onError={() => setFailed(src)}
      />
    );
  }
  return (
    <span className={`picto picto--emoji ${className}`} aria-hidden="true">
      {source.icon || '💬'}
    </span>
  );
}
